import { Expose } from "class-transformer";
import { Data } from "../data";
import { CartaoCreditoData } from "./cartao-credito.data";

@Expose()
export class CobrancaData extends Data<CobrancaData> {
  idFormaCobranca!: number;
  cartaoCredito!: CartaoCreditoData;
}




